import { BaseCrudApi } from './abstract/base-crud.api';
import { ActiveSessionsResponse } from './messages/sessions/active-sessions.response';

export class SessionsApi extends BaseCrudApi {
  constructor() {
    super('statistics-clickhouse');
  }

  async getActivateSessions(body: string[]): Promise<ActiveSessionsResponse[]> {
    return this.api
      .post<Array<ActiveSessionsResponse>>('active-sessions', body)
      .then((result) => result.data);
  }
}
